import React, { useRef, useState } from "react";
import {
  TextField,
  Button,
  Box,
  Grid,
  Alert,
  OutlinedInput,
  InputAdornment,
  IconButton,
  FormControl,
  InputLabel,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useStateContext } from "../context/ContextProvider";
import moment from "moment";

import axiosClient from "../axiosClient";
import axiosClientSevan from "../axiosClientSevan";

function Login({
  setShowSelection,
  setCustomerCompanies,
  setCustomerToken,
  setStores,
  setLoading,
}) {
  const { setToken, setStore } = useStateContext();

  const [errorMessage, setErrorMessage] = useState("");
  const [passwordVisibility, setPasswordVisibility] = useState(false);

  const emailRef = useRef();
  const passwordRef = useRef();

  const handleToggleRePasswordVisibility = () => {
    setPasswordVisibility(!passwordVisibility);
  };

  const handleLogin = () => {
    setLoading(true);
    const payloadSevan = {
      email: emailRef.current.value,
      password: passwordRef.current.value,
      platform_name: "SOFTECH",
    };

    axiosClientSevan
      .post("api/login/customer", payloadSevan)
      .then(() => {
        const payload = {
          params: {
            email: emailRef.current.value,
          },
        };

        axiosClient
          .get("auth/login", payload)
          .then((response) => {
            if (response.data.customer.Companies.length === 0) {
              setToken(response.data.accessToken);
            } else if (
              response.data.customer.Companies.length === 1 &&
              response.data.customer.Companies[0].Stores.length === 0
            ) {
              setToken(response.data.accessToken);
            } else if (
              response.data.customer.Companies.length === 1 &&
              response.data.customer.Companies[0].Stores.length === 1
            ) {
              if (
                response.data.customer.Companies[0].Stores[0].store_bill_id != 0
              ) {
                const sevanPayload = {
                  shop_code:
                    response.data.customer.Companies[0].Stores[0].store_bill_id,
                  service_id: 301,
                  platform_name: "SOFTECH",
                };

                axiosClientSevan
                  .post("api/shop/service/exist", sevanPayload)
                  .then((res) => {
                    const serviceWithExpDates = res.data.data.service_type_data;
                    const hasAServiceActive = serviceWithExpDates.filter(
                      (obj) => obj.service_type_expriration_Date != "-"
                    );

                    const currentDate = moment().format("DD-MM-YYYY");
                    let expirationDate =
                      hasAServiceActive[0].service_type_expriration_Date;

                    const momentDate1 = moment(currentDate, "DD-MM-YYYY");
                    const momentDate2 = moment(expirationDate, "DD-MM-YYYY");

                    if (momentDate1.isAfter(momentDate2)) {
                      console.log(currentDate);
                      console.log(expirationDate);
                      setErrorMessage("No active subscription!");
                    } else {
                      setToken(response.data.accessToken);
                      setStore(
                        JSON.stringify(
                          response.data.customer.Companies[0].Stores[0]
                        )
                      );
                    }
                  });
                setLoading(false);
              } else {
                setLoading(false);
                setToken(response.data.accessToken);
              }
            } else {
              const allStores = response.data.customer.Companies.map(
                (company) => company.Stores
              ).flat();
              setLoading(false);
              setShowSelection(true);
              setCustomerCompanies(response.data.customer);
              setStores(allStores);
              setCustomerToken(response.data.accessToken);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        const response = err.response;
        if (response && response.status === 422) {
          setErrorMessage(response.data.message);
          setLoading(false);
        } else {
          setErrorMessage(response.data.message);
          setLoading(false);
        }
      });
  };

  return (
    <Box sx={{ "& .MuiTextField-root": { width: "100%" } }}>
      <form>
        {errorMessage && errorMessage !== "No active subscription!" && (
          <Alert severity="error" sx={{ marginBottom: 4 }}>
            {errorMessage}
          </Alert>
        )}
        {errorMessage && errorMessage === "No active subscription!" && (
          <div style={{ flex: 1 , flexDirection: "column"}}>
            <Alert severity="error" sx={{ marginBottom: 4 }}>
              {`${errorMessage} `}
              <a href={process.env.REACT_APP_SEVAN_BASE_URL} target="_blank" rel="noreferrer">Renew it here!</a>
            </Alert>
          </div>
        )}
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="Email"
              variant="outlined"
              fullWidth
              inputRef={emailRef}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel htmlFor={`outlined-adornment-password`}>
                Password
              </InputLabel>
              <OutlinedInput
                id={`outlined-adornment-password`}
                type={passwordVisibility ? "text" : "password"}
                inputRef={passwordRef}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleToggleRePasswordVisibility}
                      edge="end"
                    >
                      {passwordVisibility ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
                label="Password"
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={handleLogin}
            >
              Sign In
            </Button>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
}

export default Login;
